module.exports = __webpack_public_path__ + "static/liquor3-151ed58892e8a27d5141608e935a5c78.jpg";